import { AuditLogDetail } from "modules/auditLog";

const ActivityLogDetailPage = () => {
  return <AuditLogDetail />;
};

export default ActivityLogDetailPage;
